import { Host, Component, Prop, h, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-button',
  styleUrls: [],
  shadow: false,
})
export class DdaButton {
  @Prop() button_type: string = 'button';
  @Prop() disabled: boolean = false;
  @Prop() start_icon_family: string = '';
  @Prop() start_icon: string = '';
  @Prop() button_text: string = '';
  @Prop() end_icon_family: string = '';
  @Prop() end_icon: string = '';
  @Prop() aria_label?: string = '';
  @Prop() button_color: string = 'primary';
  @Prop() size?: string;
  @Prop() button_shape?: string = '';
  @Prop() icon_button_shape?: string = '';
  @Prop() gap?: number;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() button_id: string;
  @Prop() button_name?: string = '';
  @Prop() value?: string;
  // @Prop() onpressKey?: () => void;

  @Event() buttonClick: EventEmitter<{ event: MouseEvent, id: string, value: string, name: string }>;

  private handleClick = (event: MouseEvent) => {
    if (this.disabled) return;

    this.buttonClick.emit({
      event,
      id: this.button_id,
      value: this.value,
      name: this.button_name,
    });
  };
 
  // private handleKeyDown = (event: KeyboardEvent) => {
  //   if (event.key === 'Enter' || event.key === ' ') {
  //     event.preventDefault();
  //     this.handleClick(event as unknown as MouseEvent);
  //   }
  // };

  render() {
    const buttonClass = [
      'dda-btn',
      `btn-color-${this.button_color}`,
      this.size ? `btn-size-${this.size}` : '',
      this.button_shape ? `btn-shape-${this.button_shape}` : '',
      this.icon_button_shape ? `icon-btn-${this.icon_button_shape}` : '',
      this.gap ? `dda-gap-${this.gap}` : '',
      this.custom_class,
      this.component_mode,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <Host>
        <button
          id={this.button_id}
          type={this.button_type}
          class={buttonClass}
          disabled={this.disabled}
          aria-label={this.aria_label || this.button_text}
          name={this.button_name}
          value={this.value}
          onClick={this.handleClick}
          // onKeyDown={this.handleKeyDown}
        >
          {this.start_icon && (
            <i class="material-icons material-symbols-outlined" aria-hidden="true">
              {this.start_icon}
            </i>
          )}
          {this.button_text}
          {this.end_icon && (
            <i class="material-icons material-symbols-outlined" aria-hidden="true">
              {this.end_icon}
            </i>
          )}
        </button>
      </Host>
    );
  }
}
